import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ProgressSpinner } from 'primereact/progressspinner';

import 'assets/css/minhas-requisicoes.css';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: '10px',
    marginBottom: '20px',
    width: '30vw',
  },
  autoComplete: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: '10px',
    marginBottom: '20px',
    width: '30vw',
  },
}));

export default function CabecalhoRequisicao({
  listaAlmoxarifados,
  setAlmoxarifadoSelecionado,
  almoxarifadoSelecionado,
  setCentroCustoSelecionado,
  centroCustoSelecionado,
  loadingRequisicao,
}) {
  const classes = useStyles();
  const profissional = JSON.parse(localStorage.getItem('profissional'));

  if (loadingRequisicao) {
    return <ProgressSpinner style={{ left: '45%' }} />;
  }

  return (
    <div className={classes.root}>
      <Autocomplete
        id="ccOrigemID"
        required
        loadingText="Carregando..."
        options={profissional.centroCusto}
        getOptionLabel={option => `${option.codigo} - ${option.nome}`}
        className={classes.autoComplete}
        value={centroCustoSelecionado}
        onChange={(e, value) => {
          setCentroCustoSelecionado(value);
        }}
        renderInput={params => <TextField {...params} label="C.C Origem" variant="outlined" />}
      />
      <Autocomplete
        id="almoxarifadoID"
        required
        loadingText="Carregando..."
        options={listaAlmoxarifados}
        getOptionLabel={option => `${option.nome}`}
        className={classes.autoComplete}
        value={almoxarifadoSelecionado}
        onChange={(e, value) => {
          setAlmoxarifadoSelecionado(value);
        }}
        renderInput={params => <TextField {...params} label="Almoxarifado" variant="outlined" />}
      />
    </div>
  );
}
